var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-report-section-info" }, [
    _c("div", { staticClass: "go-block-footer" }, [
      _c("div", { staticClass: "go-block-wrap" }, [
        _vm.getSelectedResource.userProfile
          ? _c("i", { staticClass: "go-user-thumb" }, [
              _c("img", {
                attrs: {
                  src: _vm.getSelectedResource.userProfile.imageUrl,
                  alt: "",
                },
                on: { error: _vm.onErrorImageAvatar },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "go-text-wrap" }, [
          _vm.getSelectedResource.userProfile
            ? _c("span", { staticClass: "go-user-name" }, [
                _vm._v(
                  _vm._s(_vm.$t("common.label.created-by")) +
                    " " +
                    _vm._s(_vm.getSelectedResource.userProfile.lastName)
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "go-user-time" }, [
            _vm._v(
              _vm._s(
                _vm.$t("common.label.x-min-read", {
                  x: _vm.getSelectedResource.readTimeMinute,
                })
              ) + " "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "go-icon-area" }, [
        _vm.getSelectedResource.originParentDocDetail.private_type === "PRIVATE"
          ? _c("dl", [
              _vm._m(0),
              _vm._v(" "),
              _c("dd", [_vm._v(_vm._s(_vm.$t("scrap-agent.private")))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm
          .moment(
            _vm.getSelectedResource.originParentDocDetail.created_at,
            "YYYYMMDDHHmmss"
          )
          .isValid()
          ? _c("dl", [
              _vm._m(1),
              _vm._v(" "),
              _c("dd", [
                _vm._v(
                  _vm._s(
                    _vm.formatDateAgo(
                      _vm.moment.utc(
                        _vm.getSelectedResource.originParentDocDetail
                          .created_at,
                        "YYYYMMDDHHmmss"
                      )
                    )
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("dl", [
          _vm._m(2),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.getSelectedResource.countView || 0))]),
        ]),
        _vm._v(" "),
        _c("dl", [
          _vm._m(3),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.getSelectedResource.countShare || 0))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("i", { staticClass: "go-icon-20 go-icon-private" })])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("i", { staticClass: "go-icon-20 go-icon-time" })])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("i", { staticClass: "go-icon-20 go-icon-view" })])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("i", { staticClass: "go-icon-20 go-icon-share" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }